import { useEffect, useState } from 'react'
import { useUrlFilters } from 'src/libs/useUrlFilters'
import {
  DividendListFilter,
  DividendListTable,
} from 'src/pages/finSystem/balanceSummary/reports/reportDividends/components'
import { FILTER_CONFIG_DIVIDEND } from 'src/pages/finSystem/balanceSummary/reports/const'
import { dividendListLoad } from 'src/pages/finSystem/balanceSummary/reports/reportDividends/model'
import { getPeriodByRange } from 'src/pages/finSystem/balanceSummary/reports/utils'
import { FormValue } from 'src/pages/finSystem/balanceSummary/reports/reportDividends/types'
import dayjs from 'dayjs'
import { SortDirectionT } from 'src/pages/finSystem/balanceSummary/reports/types'

export const DividendListSection = () => {
  const {
    filters,
    setFilters,
    resetFilters: reset,
  } = useUrlFilters(FILTER_CONFIG_DIVIDEND)
  const { dateFrom, dateTo, search, walletIds, sorterField } = filters
  const [sortDirection, setSortDirection] = useState<SortDirectionT>(() => {
    if (!filters?.sorterField) return undefined
    return filters?.sorterField?.startsWith('-') ? 'descend' : 'ascend'
  })

  const getInitialValueForm = () => {
    const result: FormValue = {}

    const period = getPeriodByRange(dateFrom, dateTo)
    result['period'] = period

    result['periodDatePicker'] =
      period === 'date_range' ? [dayjs(dateFrom), dayjs(dateTo)] : undefined

    result['search'] = search
    result['walletIds'] = walletIds

    return result
  }

  const resetFilters = () => {
    reset()
    setSortDirection(undefined)
  }

  useEffect(() => {
    dividendListLoad({
      dateFrom,
      dateTo,
      search,
      sorterField,
      walletIds: walletIds ?? [],
    })
  }, [dateFrom, dateTo, search, walletIds, sorterField])

  return (
    <>
      <DividendListFilter
        filters={filters}
        setFilters={setFilters}
        resetFilters={resetFilters}
        initialValueForm={getInitialValueForm()}
      />
      <br />
      <DividendListTable
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        setFilters={setFilters}
      />
    </>
  )
}
